import React, { FC } from 'react';
import styled from 'styled-components';

import { EmptyStateWrapper } from 'src/presentation/components/pages/shared/TableList';
import { PrimaryButton } from '@ad-scripts/presentation/components/common/button';

const dataAidPrefix = 'emptyState';

type EmptyStateProps = {
  buttonText: string;
  copy: string;
  docsLink: string;
  linkText: string;
  onButtonClick: Function;
};

const EmptyState: FC<EmptyStateProps> = ({ buttonText, copy, docsLink, linkText, onButtonClick }) => {
  return (
    <EmptyStateWrapper data-aid={`${dataAidPrefix}-wrapper`}>
      <EmptyContainer>
        <span>
          {`${copy} `}
          <a target="_blank" rel="noopener noreferrer" href={docsLink}>
            {linkText}
          </a>
          .
        </span>
        <ButtonContainer>
          <PrimaryButton data-aid={`${dataAidPrefix}-empty-state-button`} onClick={onButtonClick}>
            {buttonText}
          </PrimaryButton>
        </ButtonContainer>
      </EmptyContainer>
    </EmptyStateWrapper>
  );
};

const EmptyContainer = styled.span`
  align-items: center;
  display: flex;
  flex: 1 1 300px;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const ButtonContainer = styled.span`
  padding-top: 12px;
`;

export default EmptyState;
